import { Component } from '@angular/core';
import {
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-announcements',
    templateUrl: './announcements.component.html',
    styleUrls: ['./announcements.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        RouterModule,
    ],
})
export class AnnouncementsComponent {
    constructor(
        public dialogRef: MatDialogRef<AnnouncementsComponent>,
        private router: Router
    ) {}

    toHomePage() {
        localStorage.setItem('popup', 'true');
        this.router.navigate(['']);
    }
}
